import React from 'react'
import { string, array, object, bool, node } from 'prop-types'
import styled from 'styled-components'
import { Flex, Box } from 'rebass'
import { CheckboxWrapper } from '../../../utils/style'
import defaulter from '../../../../lib/defaulter'
import { sortBy } from 'lodash'
import { rem } from 'polished'

const CheckBoxRowColumn = styled(Box)`
  position: relative;
`

const CheckBoxLabelInner = styled.span`
  display: inline-block;
  font-weight: inherit;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
`

const CheckBoxLabelAddition = styled.span`
  display: inline-block;
  font-weight: ${(props) => props.theme.weights[0]};
  padding-left: ${rem(2)};
  vertical-align: top;
`

class CheckedFilters extends React.Component {
  constructor(props) {
    super(props)
    this.onCheck = this.onCheck.bind(this)
  }

  onCheck(e) {
    const selected = new Set(this.props.selected)
    const option = e.currentTarget.value
    if (!e.currentTarget.checked && selected.has(option)) {
      selected.delete(option)
    } else {
      selected.add(option)
    }
    this.props.onChange({ [this.props.type]: Array.from(selected) })
  }

  render() {
    let options = defaulter(this.props.defaults, this.props.stats)
    if (this.props.sorted) options = sortBy(options, 'key')
    const finalOptions = options.filter(
      ({ key, count }) =>
        this.props.selected.some(
          (item) => item.toLowerCase() === key.toLowerCase()
        ) ||
        !this.props.hideZeroCount ||
        count > 0
    )

    if (!finalOptions.length)
      return <Box pb={20}>{this.props.emptyMessage}</Box>

    return (
      <fieldset>
        <Flex flexWrap="wrap">
          {finalOptions.map(({ key, count }) => {
            const checked = this.props.selected.some(
              (item) => item.toLowerCase() === key.toLowerCase()
            )
            if (count === 0 || key === 'null') return null
            return (
              <CheckBoxRowColumn
                key={`option-${this.props.type}-${key}`}
                width={['100%', '50%']}
              >
                <CheckboxWrapper>
                  <input
                    type="checkbox"
                    onChange={this.onCheck}
                    id={`option-${this.props.type}-${key}`}
                    value={key}
                    checked={checked}
                  />
                  <label htmlFor={`option-${this.props.type}-${key}`}>
                    <CheckBoxLabelInner>{key}</CheckBoxLabelInner>{' '}
                    <CheckBoxLabelAddition>({count})</CheckBoxLabelAddition>
                  </label>
                </CheckboxWrapper>
              </CheckBoxRowColumn>
            )
          })}
        </Flex>
      </fieldset>
    )
  }
}

CheckedFilters.defaultProps = {
  selected: [],
  sorted: false,
  hideZeroCount: false,
  emptyMessage: 'Empty'
}

CheckedFilters.propTypes = {
  type: string.isRequired,
  defaults: array,
  stats: object,
  sorted: bool,
  selected: array,
  hideZeroCount: bool,
  emptyMessage: node
}

export default CheckedFilters
